import Env from "./env";
import { Logger } from "./logger";

export const RedirectToOnboardingPage = () => {
	const CONNECT_PORTAL_URL = Env.ConnectPortalUrls[Env.getEnvName()];
	const agreementsUrl = `${CONNECT_PORTAL_URL}account/onboarding`;
	Logger("Redirecting... -> ", agreementsUrl);
	window.location.href = agreementsUrl;
};
